import xhr from '../utils/xhr';

let api = {
    get: (filters = { query: null }, sorting = { sortBy: "nameSort", direction: "asc" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/categories/with-entities?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    getSingle: (categoryId, sorting = { sortBy: "nameSort", direction: "asc" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        return xhr.get({
            url: `/api/categories/with-entities?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}&idFilter=${categoryId}`
        });
    },

    getCategoryNames: () => {
        return xhr.get({
            url: `/api/categories/?pageNumber=-1&pageSize=-1&sortBy=nameSort&direction=asc`
        }).then((response) => {
            let categories = {};
            for (let i = 0; i < response.body.length; i++) {
                categories[response.body[i].id] = response.body[i].name;
            }
            return categories;
        });
    },

    getEmpty: (filters = { query: null }, sorting = { sortBy: "nameSort", direction: "asc" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/categories/empty?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    count: (filters = { query: null }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `?nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/categories/count${searchFilter}`
        });
    },
    deleteCategories: (categoryIds) => {
        return xhr.delete({
            url: "/api/categories/",
            data: categoryIds
        })
    },

    getEmptyCategoriesCount: (filters = { query: null }) => {
        return xhr.get({
            url: `/api/categories/empty/count`
        })
    },

    getCategoriesFeedsCount: (categoryId) => {
        return xhr.get({
            url: 'api/categories/feeds/count/' + categoryId
        })
    },

    getCategoriesAlertsCount: (categoryId) => {
        return xhr.get({
            url: 'api/categories/alerts/count/' + categoryId
        })
    },

    getCategoriesFeeds: (categoryId) => {
        return xhr.get({
            url: 'api/categories/feeds/' + categoryId + '?pageNumber=-1&pageSize=-1'
        })
    },

    getCategoriesAlerts: (categoryId) => {
        return xhr.get({
            url: 'api/categories/alerts/' + categoryId + '?pageNumber=-1&pageSize=-1'
        })
    },
    
    validateNameField: (categoryName, categoryId) => {

        let payload = {name: categoryName.trim()};

        if (categoryId) {
            payload['categoryId'] = categoryId;
        }

        return xhr.post({
            url:  '/api/categories/duplicate-name',
            data: payload
        }).then(response => response.body)

    },

    /**
     * Create category request
     * @param data { name: string, entityIds: array<string> }
     */
    createCategory: (data) => {
        return xhr.post({
            url: '/api/categories/category-with-entities',
            data
        })
    },

    /**
     * Update category request
     * @param data { name: string, entityIds: array<string> }
     */
    updateCategory: (data) => {
        return xhr.put({
            url: '/api/categories/category-with-entities',
            data
        })
    },

    getCategoryData: (categoryId) => {
        return xhr.get({
            url: '/api/categories/category/' + categoryId
        })
    },

    removeEntityFromCategory: (categoryId, companyId) => {
        let data = categoryId + "/" + companyId;
        return xhr.put({
            url: '/api/actions/remove-category/' + data
        })
    }

};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/Categories.api.js